export { createApplicationDomain } from "./application";
export { createBorrowerDomain } from "./borrower";
export { createAddressDomain } from "./address";
export { createEmploymentDomain } from "./employment";
export { createIncomeDomain } from "./income";
export { createExpenseDomain } from "./expense";
export { createAssetsDomain } from "./assets";
export { createHomeDomain } from "./home";
export { createLandDomain } from "./land";
export { createDemographicsDomain } from "./demographics";
export { createDealerDomain } from "./dealer";
export { createDocumentsDomain } from "./documents";
export type { DomainIds } from "./types";
